"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./../utils");

var _reactDom = require("react-dom");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable @typescript-eslint/prefer-optional-chain */

/* eslint-disable no-nested-ternary */

/* eslint-disable @typescript-eslint/naming-convention */

/* eslint-disable react/prop-types */
function Modal(props) {
  var close = props.close,
      submit = props.submit,
      modalList = props.modalList,
      modalContent = props.modalContent;

  var _a = modalList || {},
      modalTitle = _a.modalTitle,
      list = _a.list; // const [status, setStatus] = useState(false);
  // let flag = 0;
  // 初始值设置为不是移动端


  var _b = (0, _react.useState)(false),
      isMobile = _b[0],
      setIsMobile = _b[1];

  var modalBody = (0, _react.useRef)(null);
  var fixFunc = (0, _utils.throttle)(function () {
    var wi_w = document.documentElement.offsetWidth || document.body.offsetWidth;
    window.removeEventListener('resize', fixFunc, false);

    if (wi_w <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, 50);
  (0, _react.useEffect)(function () {
    fixFunc();
    window.addEventListener('resize', fixFunc);
    return function () {
      window.removeEventListener('resize', fixFunc);
    };
  }, []);
  var targetY = null;
  var sTop = null;
  var sH = null;
  var contentH = null;
  (0, _react.useEffect)(function () {
    var content = modalBody === null || modalBody === void 0 ? void 0 : modalBody.current;
    content === null || content === void 0 ? void 0 : content.addEventListener('touchstart', function (e) {
      targetY = Math.floor(e.targetTouches[0].clientY);
    });
    content === null || content === void 0 ? void 0 : content.addEventListener('touchmove', function (e) {
      var newTargetY = Math.floor(e.targetTouches[0].clientY);
      sTop = Math.ceil(content.scrollTop); // 当前滚动距离

      sH = Math.floor(content.scrollHeight); // 可滚动区域高度

      contentH = Math.floor(content.clientHeight); // 可视区域高度

      if (sTop <= 0 && newTargetY - targetY > 0) {
        e.preventDefault();
      } else if (sTop >= sH - contentH && newTargetY - targetY < 0) {
        e.preventDefault();
      }
    });
  }, []);
  var rootId = 'tci-overlay-root';
  var root;

  var dialog = /*#__PURE__*/_react["default"].createElement("section", {
    className: 'tci-modal-root'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'tci-modal-mask'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'tci-modal-wrap',
    onClick: function onClick() {
      if (close) {
        close();
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'tci-modal',
    style: {
      // background: 'rgba(0, 0, 0, 0.2)',
      transformOrigin: '-30.5px -90px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'tci-modal-content',
    onClick: function onClick(e) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation(); // console.log('按钮响应的事件');
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    "aria-label": "Close",
    className: "tci-modal-close",
    onClick: function onClick() {
      if (close) {
        close();
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "tci-modal-close-x"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    role: "img",
    "aria-label": "close",
    className: "anticon anticon-close tci-modal-close-icon"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6115 11.9743L5.29297 17.2928L6.70718 18.7071L12.0257 13.3885L17.34 18.7028L18.703 17.3399L13.3887 12.0256L18.7072 6.70706L17.293 5.29285L11.9745 10.6114L6.65594 5.29285L5.29297 6.65581L10.6115 11.9743Z",
    fill: "black"
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tci-modal-header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tci-modal-title",
    id: "rcDialogTitle0"
  }, modalTitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tci-modal-body",
    dangerouslySetInnerHTML: {
      __html: modalContent || ''
    },
    ref: modalBody
  }), list && list.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "tci-modal-footer"
  }, list.map(function (item, index) {
    var _a = item || {},
        type = _a.type,
        txt = _a.txt,
        href = _a.href,
        onCallback = _a.onCallback;

    switch (type) {
      case 'cancel':
        return /*#__PURE__*/_react["default"].createElement("button", {
          key: index,
          type: "button",
          className: (0, _classnames["default"])('tci-btn', {
            'tci-btn-primary': list.length === 1
          }),
          onClick: function onClick() {
            if (close) {
              close();
            }
          }
        }, href && !onCallback ? /*#__PURE__*/_react["default"].createElement("a", {
          href: href
        }, txt) : /*#__PURE__*/_react["default"].createElement("span", null, txt));

      default:
        return /*#__PURE__*/_react["default"].createElement("button", {
          key: index,
          type: "button",
          className: "tci-btn tci-btn-primary",
          onClick: function onClick() {
            onCallback && onCallback(txt) || submit();
          }
        }, href && !onCallback ? isMobile ? /*#__PURE__*/_react["default"].createElement("a", {
          href: href,
          target: "_self"
        }, txt) : /*#__PURE__*/_react["default"].createElement("a", {
          href: href,
          target: "_blank",
          rel: "noreferrer"
        }, txt) : /*#__PURE__*/_react["default"].createElement("span", null, txt));
    }
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: '24px'
    }
  })))));

  if ((typeof document === "undefined" ? "undefined" : (0, _typeof2["default"])(document)) === 'object') {
    root = root || document.getElementById(rootId);

    if (!root) {
      root = document.createElement('div');
      root.id = rootId;
      document.body.appendChild(root);
    }
  }

  return /*#__PURE__*/(0, _reactDom.createPortal)(dialog, root);
}

var _default = Modal;
exports["default"] = _default;